import React from 'react'
import './index.css'

type Props = {
    count: number | null
}

const ApprovalsTabs: React.FC<Props> = ({ count }) => {
    return (
        <div className="flex flex-row">
            <div className="w-5"></div>
            <div
                className={`w-60 h-7 content-center rounded-t-[10px] text-center text-sm text-[#181818] bg-[#f0f3f5] dark:bg-[#181818] dark:text-[#FFFFFF]`}
            >
                <div className="flex flex-row w-full h-full items-center justify-center gap-2">
                    Реестр согласований
                    {count ? (
                        <div className="flex w-fit px-2 rounded-full items-center justify-center text-[12.8px] text-[#181818] bg-[#cccccc] dark:text-[#FFFFFF] dark:bg-[#333033]">
                            {count}
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            </div>
        </div>
    )
}

export default ApprovalsTabs
